<template>
  <div class="a-input-block">
    <div class="a-input-head">
      <div class="a-input-label">{{ label }}</div>
    </div>
    <div class="a-input-body">
      <input
        class="a-input"
        v-bind="$props"
        @input="$emit('input', $event.target.value)"
        @focus="$emit('focus', $event)"
        @blur="onBlur"
        @change="$emit('change', $event)"/>
      <div :class="{ 'a-invisible': noclear||!value }" class="a-input-icon-clear" @click="onClickClear"></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      id: String,
      name: String,
      form: String,
      label: String,
      type: String,
      placeholder: String,
      value: [String, Number],
      readonly: Boolean,
      disabled: Boolean,
      noclear: Boolean
    },

    methods: {
      onBlur($event) {
        this.$emit('blur', $event)
        fixBlurBugOnMobile()
      },
      onClickClear() {
        if (!this.noclear && this.value) {
          this.$emit('input', '');
        }
      }
    }
  };

  //解决IOS系统键盘回弹页面卡死
  function fixBlurBugOnMobile() {
    setTimeout(() => {
      let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
      window.scrollTo(0, Math.max(scrollHeight - 2, 0))
    }, 100)
  }
</script>



// WEBPACK FOOTER //
// src/components/c-input.vue